
import * as React from "react";

const TOAST_LIMIT = 1;
const TOAST_REMOVE_DELAY = 1000000;

type ToastActionElement = React.ReactElement<any>;

export interface Toast {
  id?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: ToastActionElement | { label: string; onClick: () => void };
  variant?: "default" | "destructive" | "warning" | "success";
  duration?: number;
}

export interface ToasterToast extends Toast {
  id: string;
  open: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function genId() {
  return Math.random().toString(36).substr(2, 9);
}
